export default __webpack_public_path__ + "static/media/robot.9f79ffc4.jpg";